<template>
  <div id="app">
    <site-header></site-header>
    <div :class="$style.gridContainer">
      <div :class="[$style.col, $style.oneCol]" style="display: none;">
        <h2 :class="$style.title">Vinningar</h2>
          <p :class="$style.text">
            <carousel :perPage="1" :autoplay="true">
              <slide :class="$style.slide">
                <img src="./assets/wow.png" alt="">
                <p :class="[$style.sliderText, $style.prizeText]">
                  <strong>WOW air</strong> - Flug fyrir tvo til Evrópu
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/bluelagoon.jpg" alt="">
                <p :class="[$style.sliderText, $style.prizeText]">
                  <strong>Bláa Lónið</strong> fyrir tvo og út að borða á <strong>Lava Restaurant</strong>
                </p>
              </slide>
            </carousel>
          </p>
      </div>
      <div :class="[$style.col, $style.twoCol]">
        <h2 :class="$style.title">Myndaleikur</h2>
        <h3 :class="[$style.title, $style.titleSmall]">Ef þú tekur ekki mynd, þá gerðist það ekki!</h3>
        <p :class="$style.text">

          Á fimmta hundrað myndir bárust í myndaleikinn Við höfum góða sögu að segja sem fram fór í sumar.
          Þátttakendur þurftu að smella myndum af á Reykjanesi og birta á samfélagsmiðlum undir myllumerkinu #godarsogur.
          Glæsilegir vinningar voru í boði en trompvinningurinn var flugferð fyrir tvo til Evrópu með WOW.

        </p>
        <p :class="$style.text">

          Jón Óskar Hauksson, formaður Ljósops – áhugaljósmyndarafélags Suðurnesja, fékk trompvinningin fyrir fimm frábærar myndir af Reykjanesi.
          Lista yfir vinningshafa má sjá hér að neðan en þeir geta nálgast vinningana í Hljómahöllinni í Reykjanesbæ.

        </p>
        <p :class="$style.text">

          Við þökkum kærlega fyrir þátttökuna.

        </p>
      </div>
      <div :class="[$style.col, $style.oneCol]">
        <h2 :class="$style.title">Vissir þú að...</h2>
          <p :class="$style.text">
            <carousel :perPage="1" :autoplay="true">
              <slide :class="$style.slide">
                <img src="./assets/slider1.jpg" alt="">
                <p :class="$style.sliderText">
                  Útilegumannabyggð, hellir og minjar af skjóli úr steinum og steyptum veggjum, , fannst við gamla gönguleið nálægt Eldvörpum þegar Hitaveita Suðurnesja var að bora þar árið 1982? <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/slider2.jpg" alt="">
                <p :class="$style.sliderText">
                  Aðeins 8 sjómílur suður af Reykjanesi er þverhnípta klettaeyjan Eldey? Eitt skerjanna í klasanum er svokallað Geirfuglasker en þar hélt geirfuglinn síðast til. Eldey er einnig stærsta súlubyggð í heiminum! <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/slider3.jpg" alt="">
                <p :class="$style.sliderText">
                  Suður í Krýsuvík er þyrping sprengigíga og einn sá þekktasti er í raun lítið stöðuvatn sem ber heitið Grænavatn? Gígurinn er yfir 6000 ára gamall og vatnið er farið að mygla. Grín! Græni liturinn er kominn til vegna samblöndunar brennisteinstegunda. <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/slider4.jpg" alt="">
                <p :class="$style.sliderText">
                  Sogin eru 150 til 200 metra djúp vatnssorfin leirgil og hryggir?  Mikill hiti frá háhitahverum á svæðinu útskýrir litadýrðina sem einkennir þetta sérkennilega háhitasvæði sunnan Trölladyngju og Grænudyngju, skammt frá Keili. <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/slider5.jpg" alt="">
                <p :class="$style.sliderText">
                  Brennisteinsfjöll eru stór þyrping móbergsfjalla frá síðari hluta ísaldar? Í norðanverðum Brennisteinsfjöllum er háhitasvæði og í kringum 1880 voru þar brennisteinsnámur sem enn má koma auga á. <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/slider6.jpg" alt="">
                <p :class="$style.sliderText">
                  Þetta er Brimketill. Hann er staðsettur rétt hjá Grindavík. Hann varð til vegna stöðugs núnings brims við hraunkatlana. Sundgarpar eiga það til að baða sig í honum, rétt eins og Oddný Nátttröll. Hún var þarna. Hefur þú prófað? <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
              <slide :class="$style.slide">
                <img src="./assets/slider7.jpg" alt="">
                <p :class="$style.sliderText">
                  Rétt austan við Reykjanesvita er stórbrotið jarðhitasvæði? Þar er Gunnuhver, sem dregur nafn sitt af Guðrúnu nokkurri sem gekk aftur og olli miklum usla á svæðinu. Presturinn Eiríkur Magnússon kom draugsa fyrir kattarnef er hann sendi hann í einn hveranna. Langar þig að hitta Gunnu? <strong :class="$style.tag">#goðarsogur</strong>
                </p>
              </slide>
            </carousel>
          </p>
      </div>
    </div>
    <h2 :class="[$style.title, $style.titleLarge]">Vinningsmyndir</h2>
    <winners></winners>
  </div>
</template>

<script>
import styles from './styles/App.styl';
import TagplayWidget from './components/TagplayWidget.vue';
import SiteHeader from './components/SiteHeader.vue';
import Winners from './components/Winners.vue';
export default {
  name: 'app',
  components: { TagplayWidget, SiteHeader, Winners }
};
</script>

<style module lang="stylus">
  @import '~s-grid/s-grid-settings'
  @import 's-grid-functions'
  @import '~rupture/rupture/index'
  .list
    margin-left 20px
  .title
    font-size 30px
    font-weight 400
    margin 30px 0 20px
    font-family 'Roboto Condensed', sans-serif
    text-transform uppercase
    text-align center
    color #606162
    &Large
      margin 60px 0 30px
    &Small
      font-size 24px
    &::before,
    &::after
      content: '-';
      padding: 0 10px;
  .text
    padding 20px 40px
    line-height 1.6
  .sliderText
    padding-top 10px
    line-height 1.6
  .prizeText
    text-align center
    font-size 18px
    margin-top 20px
  .slide
    padding 0 10px
  .tag
    color #FFFFFF
    display inline-block
    background #0FB4BD
    padding 4px
    font-weight 400
    margin 2px 0
    font-size 13px
    line-height 1
  .gridContainer
    center(1440px, 25px)
    grid()
    +below(1440px)
      center(760px, 0px)
    +below(767px)
      center(400px, 0px)
  .fullCol
    cell(1,1,g:10px)
  .twoCol
    cell(2,3,g:10px)
    +below(1440px)
      cell(1,1)
  .oneCol
    padding-bottom 20px
    cell(1,3,g:10px)
    +below(1440px)
      cell(1,1)
  .col
    background white
    min-height 640px
    &__places
      +below(1440px)
        cell(1,1)
</style>



// WEBPACK FOOTER //
// App.vue?3101258c